/***
HEADER
***/

function openMiniLogin() {
  $(document).ready(function () {
    // Add the required classes and styles to open the mini login
    $("html").addClass("miniLoginOpened");
    $("#miniLogin").css("transform", "translateX(0)");
    setTimeout(function () {
      $("body").addClass("openMiniLogin");
    }, 301);
  });
}




function closeMiniLogin() {
  $(document).ready(function() {
    $("html").removeClass("miniLoginOpened");
    $("body").removeClass("openMiniLogin");
    setTimeout(function(){
      $("#miniLogin").css("transform","translateX(2500px)");
    }, 301);
  });
}

function openRegisterSection() {
  $("#container-register").removeClass("hidden");
  $("#container-login").addClass("hidden");
}

function goBackToLoginSection() {
  $("#container-register").addClass("hidden");
  $("#container-reset-password").addClass("hidden");
  $("#container-login").removeClass("hidden");
}

function openRecoverSection() {
  $("#container-reset-password").removeClass("hidden");
  $("#container-login").addClass("hidden");
}

$(".submenu-go-back").on( "click", function() {
  $(this).parent().parent().parent().parent().removeAttr("open");
});


/***
MY ACCOUNT
***/

if($("main").hasClass("template-customers-account")) {
  var url = window.location.href;
  var urlPath = url.split('#');

  if(urlPath[1] == "my-personal-information") {
    $("#my-profile").addClass("hidden");
    $("#my-personal-information").removeClass("hidden");
    $("#my-subscription").addClass("hidden");
    $("#my-orders").addClass("hidden");
  }

  if(urlPath[1] == "my-orders") {
    $("#my-profile").addClass("hidden");
    $("#my-personal-information").addClass("hidden");
    $("#my-subscription").addClass("hidden");
    $("#my-orders").removeClass("hidden");
  }

  if(urlPath[1] == "my-subscription") {
    $("#my-profile").addClass("hidden");
    $("#my-personal-information").addClass("hidden");
    $("#my-subscription").removeClass("hidden");
    $("#my-orders").addClass("hidden");
  }

  if(urlPath[1] == "my-measurements") {
    $("#my-profile").addClass("hidden");
    $("#my-personal-information").addClass("hidden");
    $("#my-subscription").addClass("hidden");
    $("#my-orders").addClass("hidden");
    $("#my-measurements").removeClass("hidden");
  }

  $("#container-account-information").removeClass("hidden");
  
  // My profile
  $("#headingMyprofile").on("click", function(e) {
    e.preventDefault();
    $("#submenu-my-personal-information").removeClass("underline");
    $("#mainmenu-my-orders").removeClass("underline");
    $("#mainmenu-my-subscription").removeClass("underline");
    $("#mainmenu-my-measurements").removeClass("underline");
    $("#my-profile").removeClass("hidden");
    $("#my-personal-information").addClass("hidden");
    $("#my-subscription").addClass("hidden");
    $("#my-orders").addClass("hidden");
    $("#my-measurements").addClass("hidden");
  });
  // My personal information
  $("#submenu-my-personal-information,#editProfile").on("click", function(e) {
    e.preventDefault();
    $(this).addClass("underline");
    $("#my-profile").addClass("hidden");
    $("#my-personal-information").removeClass("hidden");
    $("#my-subscription").addClass("hidden");
    $("#my-orders").addClass("hidden");
    $("#my-measurements").addClass("hidden");
  });
  // My subscription
  $("#mainmenu-my-subscription").on("click", function(e) {
    e.preventDefault();
    $(this).addClass("underline");
    $("#submenu-my-personal-information").removeClass("underline");
    $("#mainmenu-my-orders").removeClass("underline");
    $("#mainmenu-my-measurements").removeClass("underline");
    $("#my-profile").addClass("hidden");
    $("#my-personal-information").addClass("hidden");
    $("#my-subscription").removeClass("hidden");
    $("#my-orders").addClass("hidden");
    $("#my-measurements").addClass("hidden");
  });
  // My orders
  $("#mainmenu-my-orders,.orders-block a").on("click", function(e) {
    e.preventDefault();
    $(this).addClass("underline");
    $("#submenu-my-personal-information").removeClass("underline");
    $("#mainmenu-my-subscription").removeClass("underline");
    $("#mainmenu-my-measurements").removeClass("underline");
    $("#my-profile").addClass("hidden");
    $("#my-personal-information").addClass("hidden");
    $("#my-subscription").addClass("hidden");
    $("#my-orders").removeClass("hidden");
    $("#my-measurements").addClass("hidden");
  });
  // My measurements
  $("#mainmenu-my-measurements").on("click", function(e) {
    //e.preventDefault();
    window.scrollTo(0, 0);
    $(this).addClass("underline");
    $("#submenu-my-personal-information").removeClass("underline");
    $("#mainmenu-my-orders").removeClass("underline");
    $("#mainmenu-my-subscription").removeClass("underline");
    $("#my-profile").addClass("hidden");
    $("#my-personal-information").addClass("hidden");
    $("#my-subscription").addClass("hidden");
    $("#my-orders").addClass("hidden");
    $("#my-measurements").removeClass("hidden");
  });

  // My measurements - Button Back
  $(document).ready(function() {
    setTimeout(function() {
      $(".cf-submit-form").click(function() {
        setTimeout(function() {
          $(".back-to-measurements a").css("display","block");
          $(".back-to-measurements a").click(function() {
            location.reload();
          });
        }, 500);
      });
    }, 500);
    setTimeout(function() {
      $(".cf-submit-form").click(function() {
        setTimeout(function() {
          $(".back-to-measurements a").css("display","block");
          $(".back-to-measurements a").click(function() {
            location.reload();
          });
        }, 1000);
      });
    }, 1000);
    setTimeout(function() {
      $(".cf-submit-form").click(function() {
        setTimeout(function() {
          $(".back-to-measurements a").css("display","block");
          $(".back-to-measurements a").click(function() {
            location.reload();
          });
        }, 2000);
      });
    }, 2000);
    setTimeout(function() {
      $(".cf-submit-form").click(function() {
        setTimeout(function() {
          $(".back-to-measurements a").css("display","block");
          $(".back-to-measurements a").click(function() {
            location.reload();
          });
        }, 3000);
      });
    }, 3000);
  });
}


/***
PDP
***/

if($("main").hasClass("template-product")) {
  $(document).ready(function() {
    if($("#shopify-block-ultimate_recently_viewed_recently_viewed_HKD7cb .ultimate-recently-viewed").is(':empty')) {
      $("#shopify-block-ultimate_recently_viewed_recently_viewed_HKD7cb .ultimate-recently-viewed").append('<p style="text-align: center;">Products not exists</p>');
    }
    // ZOOM PDP
    /*$(".main-image .slide").on("click", function() {
      if($(this).hasClass("slick-active")) {
        if($(this).hasClass("add-zoom")) {
          $(this).removeClass("add-zoom");
          $(".slideshow-controls__arrows").removeClass("hidden");
        } else {
          $(this).addClass("add-zoom");
          $(".slideshow-controls__arrows").addClass("hidden");
          var addZoom = $(this);
          $(document).mousemove(function(getCurrentPos){
            var xCord = getCurrentPos.pageX;
            var yCord = getCurrentPos.pageY;
            xPercent = xCord / $(document).width() * 100;
            yPercent = yCord / $(document).height() * 500;
            addZoom.find(".rimage-wrapper").css("--zoom-position-x",xPercent+"%");
            addZoom.find(".rimage-wrapper").css("--zoom-position-y",yPercent+"%");
          });
        }
      }
    });*/
    // Video in PDP
    $('.thumbnails, .slick-product-next.slick-arrow').on('click', function(e){
     e.preventDefault();
     setTimeout(function(){
       if($('.slick-current').find('video').length > 0 ){
          $('.slick-slide video').attr('loop','false');
          $('.slick-slide video').trigger('pause');
          $('.slick-current video').attr('loop','true');
          $('.slick-current video').trigger('play');
       }
     }, 600);
    });
    $('.product-slideshow').on('afterChange', function(event, slick, currentSlide){
       setTimeout(function(){
         if($('.slick-current').find('video').length > 0 ){
            $('.slick-slide video').attr('loop','false');
            $('.slick-slide video').trigger('pause');
            $('.slick-current video').attr('loop','true');
            $('.slick-current video').trigger('play');
         }
       }, 600);
    });
    // Open contact popup
    $("#openContactUs").on("click", function(){
      $("#popup-contact-us").addClass("open");
      $("html").addClass("popup-contact-us-opened");
    });
    $("#popup-contact-us button").on("click", function(){
      $("#popup-contact-us").removeClass("open");
      $("html").removeClass("popup-contact-us-opened");
    });
  });
}


/***
PLP
***/

if($("main").hasClass("template-collection")) {
  $(document).ready(function() {
    // Check if color swatch is empty
    if ($('#more-info .container-gdl-product-group--item .gdl-product-group--item').is(':empty')){
      $("#more-info").addClass("column-reverse");
    }
    // Remove collection list from collection page filtered
    if($("#shopify-section-main > div").length == 0) {
      $("#section-collection-list.collection-listing").removeClass("hidden");
    }
  });
}
// Fix: mobile variant selector timing issue (Symmetry theme v6.0.3)
// On mobile, the change event fires before :checked/aria-selected updates.
// This override defers the option reading by 10ms to ensure DOM is updated.
(function () {
  var originalHandler = null;

  $(document).on('change.mobileVariantFix', '.option-selectors', function (e) {
    var $multiOption = $(this);
    var $productForm = $multiOption.closest('.product-form');
    var productData = theme.OptionManager.getProductData($productForm);

    setTimeout(function () {
      var selectedOptions = [];
      $multiOption.find('.option-selector').each(function () {
        if ($(this).data('selector-type') === 'listed') {
          selectedOptions.push($(this).find('.js-option:checked').val());
        } else {
          selectedOptions.push($(this).find('.js-option[aria-selected="true"]').data('value'));
        }
      });

      // Find matching variant
      var variant = false;
      for (var i = 0; i < productData.variants.length; i++) {
        var v = productData.variants[i];
        var matchCount = 0;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] == selectedOptions[j]) {
            matchCount++;
          }
        }
        if (matchCount == selectedOptions.length) {
          variant = v;
          break;
        }
      }

      if (variant) {
        // Update the hidden input and dispatch change
        $productForm.find('[name="id"]').val(variant.id).each(function () {
          this.dispatchEvent(new CustomEvent('change', {
            bubbles: true,
            cancelable: false,
            detail: { variant: variant, selectedOptions: selectedOptions }
          }));
        });
      }
    }, 10);
  });
})();
